
import React from 'react'
import { connect } from 'react-redux'
import { Dimmer, Loader, } from 'semantic-ui-react'
import { compose, withProps } from 'recompose';
import { getIsLoading } from '../selectors'

const LoadingDialog = (props) => {
	return props.isLoading ?
		<Dimmer active>
			<Loader size='large'>Loading</Loader>
		</Dimmer>
		:
		""
}

export default compose(
	connect(
		(state) => {
			return {
				isLoading: getIsLoading(state),
			}
		}
	),
	withProps(props => {
		return {
			...props,
		}
	})

)(LoadingDialog)


// WEBPACK FOOTER //
// ./src/features/ui/components/LoadingDialog.js